import { Link } from 'react-router-dom';

import type { HomeResource } from '@/types/bootstrap';

/**
 * ResourceHub — row with thumbnail + mono-caps title + body snippet.
 * Same row pattern as TaskList; whole row is the click target.
 */
export function ResourceHub({ items }: { items: HomeResource[] }) {
  return (
    <ul className="flex flex-col gap-10">
      {items.map((r) => (
        <li key={r.slug}>
          <Link
            to={
              r.kind === 'guide'
                ? `/app/learn/${r.slug}`
                : `/app/learn/article/${r.slug}`
            }
            className="block hover:opacity-90 bg-raised"
          >
            <div className="flex border border-[#ECECEC]">
              <img
                src="/brand/clinic-scene.png"
                alt=""
                aria-hidden
                className="w-[10rem] aspect-square object-cover bg-[var(--surface-sunken)]"
              />
              <div className="flex-1 min-w-0 px-15 py-15 flex flex-col items-start justify-center gap-5 min-h-[10rem]">
                <div className="font-mono text-15 uppercase text-black leading-110 text-balance">
                  {r.title}
                </div>
                {r.snippet && (
                  <p className="font-body text-13 text-[#7C7C7C]">
                    {r.snippet}
                  </p>
                )}
              </div>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
}
